import { createSelector } from "reselect";

import { initialAuthenticationState } from "./data";

const selectAuthenticationState = (state) => state.authentication;

const userDetails = createSelector(
  [selectAuthenticationState],
  (authentication) =>
    authentication.userDetails || initialAuthenticationState.userDetails
);

const signUpDetails = createSelector(
  [selectAuthenticationState],
  (authentication) =>
    authentication.signUpDetails || initialAuthenticationState.signUpDetails
);

const token = createSelector(
  [selectAuthenticationState],
  (authentication) => authentication.token || initialAuthenticationState.token
);

const selectors = { userDetails, signUpDetails, token };

export default selectors;
